var React = require('react');

function ResourceMediumVideoInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.6","y":"0.6","width":"13.8","height":"9.85263","rx":"1.21115","stroke":"#717171","strokeWidth":"1.2","key":0}),React.createElement("path",{"d":"M9.99623 5.6884L6.37394 7.77973C6.1727 7.89591 5.92116 7.75068 5.92116 7.51831L5.92116 3.33565C5.92116 3.10328 6.17271 2.95805 6.37394 3.07423L9.99623 5.16556C10.1975 5.28175 10.1975 5.57221 9.99623 5.6884Z","fill":"#717171","stroke":"#717171","strokeWidth":"0.603715","key":1})]);
}

ResourceMediumVideoInline.defaultProps = {"width":"15","height":"12","viewBox":"0 0 15 12","fill":"none"};

module.exports = ResourceMediumVideoInline;

ResourceMediumVideoInline.default = ResourceMediumVideoInline;
